<template>
  <div class="auth-page">
    <div class="container-fluid p-0">
      <div class="row g-0 align-items-center">
        <div class="col-xxl-4 col-lg-4 col-md-6">
          <div class="row justify-content-center g-0">
            <div class="col-xl-9">
              <div class="card mb-0">
                <div class="card-body">
                  <div class="auth-full-page-content rounded d-flex p-3 my-2">
                    <div class="w-100">
                      <div class="d-flex flex-column h-100">
                        <div class="mb-5 mb-md-5">
                          <div class="d-block auth-logo">
                            <img 
                              src="@/assets/img/logo-argusblack.png" alt="Logo argusblack"
                              height="50" class="auth-logo-dark me-start"
                            />
                            <img
                              src="@/assets/img/logo-argusblack-blanco.png" alt="Logo argusblack"
                              height="50" class="auth-logo-light me-start"
                            />
                          </div>
                        </div>
                        <div class="auth-content my-auto">
                          <div class="text-center">
                            <h5 class="mb-1">Instalador de ArgusBlack</h5>
                            <p class="text-muted mt-2">
                              Estás a un paso de instalar y comenzar a administrar tu ISP
                              desde un solo lugar.
                            </p>
                            <p class="fw-semibold text-primary">
                              La instalación es rápida y segura.
                            </p>
                          </div>
                          <div
                            id="instalador"
                            class="mt-5 pt-2 mb-5"
                            role="form"
                            style="display: none;"
                          >
                            <button
                              class="btn btn-primary w-100 waves-effect waves-light"
                              @click="instaladorArgus()"
                            >
                              <i class="mdi mdi-progress-download me-1"></i>
                              Instalar ArgusBlack
                            </button>

                            <small class="d-block text-muted text-center mt-2">
                              Se agregará a tu dispositivo como una aplicación.
                            </small>
                          </div>
                          <div class="mt-4 pt-3 text-center">
                            <small class="text-muted">
                              ¿Ya tienes ArgusBlack instalado?
                              <a href="javascript:void(0);" @click="irLogin()" class="fw-semibold">
                                Ir al Login
                              </a>
                            </small>
                          </div>
                        </div>
                        <div class="mt-4 text-center">
                          <img
                            src="../assets/img/logo-hecho-en-mexico.png"
                            class="mb-2"
                            style="max-height: 40px;"
                          />

                          <small class="d-block">
                            <strong>ArgusBlack</strong> es mantenido por
                            <a href="https://livaur.com" target="_blank" rel="noopener noreferrer">
                              Livaur
                            </a> · {{ anio }}
                          </small>

                          <small class="text-muted">
                            Versión <strong>{{ version }}</strong>
                          </small>
                        </div>
                        <br v-if="visibleModo" />
                        <div class="rounded overflow-hidden text-center" v-if="visibleModo">
                          <div class="bg-warning bg-gradient p-1">
                            <h5 class="my-2 text-white">
                              {{ modoDes == "development" ? "Development" : "" }}
                              {{ modoDes == "testing" ? "Testing" : "" }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-8 col-lg-8 col-md-6 d-none d-sm-block">
          <div class="auth-bg bg-white py-md-5 p-4 d-flex">
            <div class="bg-overlay bg-white"></div>
            <div class="row justify-content-center align-items-center">
              <div class="col-xl-8">
                <div class="mt-4">
                  <img src="@/assets/img/login-img.png" class="img-fluid" alt="Login imagen" />
                </div>
                <div class="p-0 p-sm-4 px-xl-0 py-5">
                  <div
                    id="reviewcarouselIndicators"
                    class="carousel slide auth-carousel"
                    data-bs-ride="carousel"
                  >
                    <div class="carousel-indicators carousel-indicators-rounded">
                      <button
                        type="button"
                        data-bs-target="#reviewcarouselIndicators"
                        data-bs-slide-to="0"
                        class="active"
                        aria-current="true"
                        aria-label="Slide 1"
                      ></button>
                      <button
                        type="button"
                        data-bs-target="#reviewcarouselIndicators"
                        data-bs-slide-to="1"
                        aria-label="Slide 2"
                      ></button>
                      <button
                        type="button"
                        data-bs-target="#reviewcarouselIndicators"
                        data-bs-slide-to="2"
                        aria-label="Slide 3"
                      ></button>
                    </div>
                    <div class="carousel-inner w-75 mx-auto">
                      <div class="carousel-item active">
                        <div class="testi-contain text-center">
                          <h5 class="font-size-20 mt-4">Usa múltiples servicios</h5>
                          <p class="font-size-15 text-muted mt-3 mb-0">
                            Puedes usar múltiples líneas de internet en el mismo router y
                            definir qué clientes saldrán por alguno de esos servicios de
                            internet.
                          </p>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="testi-contain text-center">
                          <h5 class="font-size-20 mt-4">Sistema Cloud</h5>
                          <p class="font-size-15 text-muted mt-3 mb-0">
                            No necesitas tener un servidor dedicado, el sistema trabaja y
                            administra tu red sin importar en qué parte del mundo te
                            encuentres.
                          </p>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="testi-contain text-center">
                          <h5 class="font-size-20 mt-4">Administración automática</h5>
                          <p class="font-size-15 text-muted mt-3 mb-0">
                            Encargate de instalar más servicios de internet a tus
                            clientes, ArgusBlack se encargará de la parte administrativa,
                            facturación, cortes automáticos, control de ancho de banda,
                            administración de reuso de internet, etc.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SesionSrv from '@/services/SesionSrv.js'
import { todoMethods } from "@/state/helpers"
import SistemaSrv from "@/services/SistemaSrv.js"
import { version } from "../../package"

export default {
  data() {
    return {
      procesando: false,
      modoDes: "",
      visibleModo: false,
      version: version
    }
  },
  computed: {
    anio: {
      get() {
        return this.$store.state.todo.anio
      }
    }
  },
  mounted() {
    if (localStorage.getItem("argusblack.theme.mode") == "light") {
      document.body.removeAttribute("data-sidebar")
      document.body.removeAttribute("data-layout-mode")
    } else {
      document.body.setAttribute("data-sidebar", "dark")
      document.body.setAttribute("data-layout-mode", "dark")
    }

    if(window.deferredPrompt != null) {
      let instalador = document.getElementById('instalador')
      instalador.style.display = 'block'
    }
  },
  created: function () {
    this.modoDesarrollo()

    window.addEventListener('beforeinstallprompt', (e) => {
      let instalador = document.getElementById('instalador')
      instalador.style.display = 'block'
      window.deferredPrompt = e
    })

    // 👇 CUANDO YA SE INSTALÓ
    window.addEventListener("appinstalled", () => {
      window.deferredPrompt = null
      this.irLogin()
    })
  },
  methods: {
    ...todoMethods,
    instaladorArgus:function() {
      if (window.deferredPrompt !== null) {
        window.deferredPrompt.prompt()
        const { outcome } = window.deferredPrompt.userChoice
        if (outcome === 'accepted') {
          window.deferredPrompt = null
        }
      } else {
        iu.msg.warning("Debe de recargar la vista para cargar el instalador correctamente")
      }
    },

    irLogin: function() {
      SesionSrv.cerrar()
      this.limpiarUsuario()
      this.$router.push({ name: 'login' })
    },
    
    modoDesarrollo() {
      var self = this

      SistemaSrv.modo().then((response) => {
        self.modoDes = response.data
        if (self.modoDes != "production") self.visibleModo = true
        else self.visibleModo = false
      })
    }
  }
}
</script>

<style>
.text-center {
  text-align: center
}
</style>